import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ICON } from '@core/util/icon';

@Component({
	selector: 'app-contact-info-form',
	templateUrl: './contact-info-form.component.html',
	standalone: false,
})
export class ContactInfoFormComponent {
	@Input() group: FormGroup;
	public globalIcon = ICON.GLOBE;
	public labelTooltip = 'This is global data';
}
